import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import Header from "../../components/header";

import "./styles.css";
import "../../styles/Loader.css";

const EarRestricted = () => {
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);
  return (
    <div>
      <div>
        <Header
          headerHeading="NVIDIA Application Hub"
          loginHeader={true}
          dashboardHeader={false}
        ></Header>
        <div className="centered-message-app">
          <div className="centered-message">
            <p>
                         
               Your registration could not be allowed in compliance with U.S. Government policy.
               
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EarRestricted;